import { render } from "./Default.vue?vue&type=template&id=5832fd59"
import script from "./Default.vue?vue&type=script&lang=js"
export * from "./Default.vue?vue&type=script&lang=js"

const cssModules = script.__cssModules = {}
import style0 from "./Default.vue?vue&type=style&index=0&id=5832fd59&lang=scss&module=true"
cssModules["$style"] = style0
script.render = render

export default script